import { gql } from "@apollo/client";

export const PLAN_FRAGMENT = gql`
  fragment PlanFragment on Plan {
    id
    name
    provider {
      id
      name
    }
    priceInCents
    accessType
    periodUnit
    isDisplayed
    platform
    trialPeriod
    trialPeriodUnit
    countries {
      id
      isoCode
      name
    }
    createdAt
    updatedAt
    isLegacy
    isBestValue
    isSpecial
    monthlyCostInCents
    annualSavingsInCents
    monthlySavingsInPercent
  }
`;

export const GET_PLANS = gql`
  query GetPlans(
    $filter: PlanFilter
    $pagination: ConnectionArgs
    $sort: OrderByInput
  ) {
    admin {
      plans(filter: $filter, pagination: $pagination, sort: $sort) {
        edges {
          node {
            ...PlanFragment
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
  ${PLAN_FRAGMENT}
`;

export const GET_PLAN = gql`
  query GetPlan($id: String!) {
    admin {
      planById(id: $id) {
        ...PlanFragment
      }
    }
  }
  ${PLAN_FRAGMENT}
`;

export const UPDATE_PLAN_SETTINGS = gql`
  mutation UpdatePlanSettings($id: String!, $input: UpdatePlanSettingsInput!) {
    adminPlanUpdateSettings(id: $id, input: $input) {
      id
      accessType
      isDisplayed
    }
  }
`;

export const ASSIGN_COUNTRY_TO_PLAN = gql`
  mutation AssignCountryToPlan($input: AssignPlanToCountryInput!) {
    adminPlanAssignCountry(input: $input) {
      ...PlanFragment
    }
  }
  ${PLAN_FRAGMENT}
`;

export const REMOVE_COUNTRY_FROM_PLAN = gql`
  mutation RemoveCountryFromPlan($input: RemovePlanFromCountryInput!) {
    adminPlanRemoveCountry(input: $input) {
      ...PlanFragment
    }
  }
  ${PLAN_FRAGMENT}
`;
